/**
 * Die Regel fuer Interaktionszustaende der Freigabeseite (Gesamt-Review B2,
 * Auftraggeber-Entscheidung 2026-09-28, "strukturell + Test").
 *
 * Die Seite haelt Zustaende, die gegen einen bestimmten Text entstanden sind: eine gemeldete
 * Auswahl (Blockindizes, Position), den Anker eines offenen Kommentarfelds, den Schnappschuss
 * hinter "Rückgängig" und den Blockindex eines Klicks. Frueher zog jedes Ereignis ihre
 * Gueltigkeit einzeln nach, und jedes Review fand einen Weg, auf dem einer davon veraltet
 * weiterwirkte (dreimal dieselbe Fehlerklasse).
 *
 * Deshalb: Jeder neue Text bekommt einen neuen Textstand, eine fortlaufende Zahl
 * (`FreigabePage.setzeSegmente`, der einzige Weg zu neuen Segmenten). Jeder dieser Zustaende
 * traegt den Stand, auf dem er entstand, und wird DORT geprueft, wo er wirkt -- nicht bei den
 * Ereignissen, die ihn veralten lassen koennten. Ein Zaehler statt der Identitaet des Textes,
 * weil "Rückgängig" einen frueheren Text wiederherstellt: Derselbe Text ist dann ein neuer
 * Stand, und ein Zustand von vor der Aktion gilt nicht still wieder.
 */
export interface Stempel {
  /** Der Textstand, gegen den dieser Zustand entstand. */
  stand: number;
}

/**
 * Gilt ein gestempelter Zustand fuer den Text mit dem Stand `aktuell`? Bei gleichem Stand ja.
 * Sonst entscheidet `nachpruefen`, ob er inhaltlich noch passt (die Markierung steht noch an
 * ihren Offsets, am Index steht noch derselbe Block). Ohne `nachpruefen` verfaellt er.
 */
export function giltFuer(zustand: Stempel, aktuell: number, nachpruefen?: () => boolean): boolean {
  if (zustand.stand === aktuell) return true;
  return nachpruefen ? nachpruefen() : false;
}
